import React, { lazy, useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import loyaltyCapabilities from "@Src_main/config/loyalty";
import { useIntl } from "react-intl";
import ScrollToTop from "@Src_main/utils/scrollToTop";
import CreateAccountPage from "@Components/CreateAccountPage";
import { env } from "build/env";
import { useExponea } from "@Src_main/utils/useExponea";
import { captureAttribution } from "@Src_main/utils/attribution";
const OrderPage = lazy(() => import("@Pages/OrderPage/order"));
const OrderPageFromRestaurant = lazy(() => import("@Pages/OrderPage/orderFromRestaurant"));
const LoginPage = lazy(() => import("@Pages/LoginPage/loginPage"));
const CheckoutNormalPage = lazy(() => import("../overrides/venia-ui/components/CheckoutPage/checkoutNormalPage"));
const LoginFeedback = lazy(() => import("../pages/LoginFeedback"));
const PwdRecovery = lazy(() => import("../pages/PwdRecovery"));
const PreLogin = lazy(() => import("../pages/PreLogin"));
const MenuTakeaway = lazy(() => import("../pages/MenuTakeaway"));
const BookTable = lazy(() => import("../pages/BookTable"));
const Stores = lazy(() => import("../pages/Stores"));
const MyAccount = lazy(() => import("../pages/MyAccount"));
const Reservations = lazy(() => import("../pages/Reservations"));
const MyEvents = lazy(() => import("../pages/MyEvents"));
const Orders = lazy(() => import("../pages/OrderDetails"));
const MyAccountData = lazy(() => import("../pages/MyAccountData"));
const CookieCheck = lazy(() => import("./../pages/CookiesCheck"));
const PuntiSeeds = lazy(() => import("../pages/PuntiSeeds"));
const TablePage = lazy(() => import("../pages/TableStatus/TablePage"));
const ReceiptRoot = lazy(() => import("../pages/Receipt/ReceiptRoot"));
const MagentoRoute = lazy(() => import("../overrides/venia-ui/components/MagentoRoute"));
const CouponPage = lazy(() => import("../pages/CouponPage/couponPage"));
const LinkTicketPage = lazy(() => import("../pages/LinkTicket/linkTicket"));
const ConsentManagement = lazy(() => import("../pages/ConsentManagement"));
const KioskLoginRoot = lazy(() => import("../pages/KioskLogin/KioskLoginRoot"));
const Homepage = lazy(() => import("../pages/AppHomepage/appHomepage"));
const EventBooking = lazy(() => import("../pages/EventBooking"));
const EventBookingManage = lazy(() => import("../pages/EventBooking/manage"));
const PrivateEvent = lazy(() => import("../pages/PrivateEvent"));
const Participation = lazy(() => import("../pages/Participation"));
const ParticipationManage = lazy(() => import("../pages/Participation/manage"));
const ExternalRedirect = () => {
  const {
    trackAllEvent
  } = useExponea();
  const {
    URL_MISCUSI
  } = env;
  const target = window.location.protocol + "//" + URL_MISCUSI + window.location.pathname;
  trackAllEvent("redirect_brand", {
    target_url: target
  });
  window.location.replace(target);
  return null;
};
const Routes = () => {
  const {
    formatMessage
  } = useIntl();
  const {
    IS_COUPON_ACTIVE
  } = env;

  // First landing wins: utm_* + referrer are kept in sessionStorage for event bookings (AN-004/005).
  useEffect(() => {
    try {
      captureAttribution();
    } catch (error) {
      // attribution is best effort
    }
  }, []);
  const routeStructure = /*#__PURE__*/React.createElement(ScrollToTop, null, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/",
    component: MenuTakeaway
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.checkout"
    })
  }, /*#__PURE__*/React.createElement(CheckoutNormalPage, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.pre.login"
    })
  }, /*#__PURE__*/React.createElement(PreLogin, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.app.login"
    })
  }, /*#__PURE__*/React.createElement(PreLogin, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/login-feedback"
  }, /*#__PURE__*/React.createElement(LoginFeedback, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.book.a.table"
    })
  }, /*#__PURE__*/React.createElement(BookTable, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.restaurants"
    }) + "/:id/:param?",
    component: Stores
  }), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.myaccount"
    })
  }, /*#__PURE__*/React.createElement(MyAccount, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.login"
    })
  }, /*#__PURE__*/React.createElement(LoginPage, {
    isLandingPage: true
  })), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.signup"
    })
  }, /*#__PURE__*/React.createElement(CreateAccountPage, {
    isLandingPage: true,
    isPage: true,
    showHeader: false
  })), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.loyalty.data"
    })
  }, /*#__PURE__*/React.createElement(MyAccountData, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.loyalty.consents"
    })
  }, loyaltyCapabilities.consentManagement ? /*#__PURE__*/React.createElement(ConsentManagement, null) : /*#__PURE__*/React.createElement(Redirect, {
    to: formatMessage({
      id: "url.key.myaccount"
    })
  })), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.event.booking.manage"
    })
  }, /*#__PURE__*/React.createElement(EventBookingManage, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.event.booking"
    })
  }, /*#__PURE__*/React.createElement(EventBooking, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/evento-privato/:token"
  }, /*#__PURE__*/React.createElement(PrivateEvent, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/partecipa/gestisci/:manageToken"
  }, /*#__PURE__*/React.createElement(ParticipationManage, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/partecipa/:token"
  }, /*#__PURE__*/React.createElement(Participation, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.loyalty.events"
    })
  }, /*#__PURE__*/React.createElement(MyEvents, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.loyalty.reservations"
    })
  }, /*#__PURE__*/React.createElement(Reservations, null)), /*#__PURE__*/React.createElement(Route, {
    path: formatMessage({
      id: "url.key.loyalty.orders"
    })
  }, /*#__PURE__*/React.createElement(Orders, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.order"
    }),
    component: OrderPage
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "".concat(formatMessage({
      id: "url.key.order.from.restaurant"
    }), "/:restaurantId"),
    component: OrderPageFromRestaurant
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/checkCookies"
  }, /*#__PURE__*/React.createElement(CookieCheck, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.loyalty.history"
    })
  }, /*#__PURE__*/React.createElement(PuntiSeeds, null)), IS_COUPON_ACTIVE ? /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.coupon"
    })
  }, /*#__PURE__*/React.createElement(CouponPage, null)) : null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/customer/account/createPassword",
    component: PwdRecovery
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.pay"
    }),
    component: TablePage
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/payment/:paymentId",
    component: ReceiptRoot
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/kiosklogin/:connectionId/:challenge",
    component: KioskLoginRoot
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.loyalty.linkTicket"
    })
  }, /*#__PURE__*/React.createElement(LinkTicketPage, null)), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: formatMessage({
      id: "url.key.app.home"
    }),
    component: Homepage
  }), /*#__PURE__*/React.createElement(Route, {
    component: ExternalRedirect
  })));
  return routeStructure;
};
export default Routes;